import { SummaryCard } from '@/components/common/SummaryCard'
import { PeriodTotals } from '@/hooks/useWizardReviewController'

interface ReviewSummaryHeaderProps {
  totals: PeriodTotals
}

function formatCurrency(amount: number): string {
  return amount.toLocaleString('sv-SE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }) + ' kr'
}

export function ReviewSummaryHeader({ totals }: ReviewSummaryHeaderProps) {
  const driverCountText = totals.includedCount === totals.driverCount
    ? `${totals.driverCount}`
    : `${totals.includedCount} / ${totals.driverCount}`

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <SummaryCard
        title="TOTAL BRUTTOLÖN"
        value={formatCurrency(totals.totalGrossSalary)}
        subtitle="Före skatt och arbetsgivaravgifter"
      />
      <SummaryCard
        title="ATT UTBETALA"
        value={formatCurrency(totals.totalAmountToPay)}
        subtitle="Efter skatt, avdrag och oskattad dricks"
      />
      <SummaryCard
        title="ANTAL FÖRARE"
        value={driverCountText}
        subtitle={totals.includedCount < totals.driverCount
          ? `${totals.driverCount - totals.includedCount} exkluderade`
          : 'Alla förare inkluderade'
        }
      />
    </div>
  )
}
